"use strict";

import Tab from 'bootstrap/js/dist/tab';

export function init() {
    let tabTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tab"]'))
    let tabList = tabTriggerList.map(function (tabTriggerEl) {
        return new Tab(tabTriggerEl);
    })
}